/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

const SI_SYMBOL = ["", "k", "M", "G", "T", "P", "E"];

export const abbreviateNumber = (number: number): string => {
  if (number !== 0 && inRange(number, -1, 1)) {
    return `${number.toFixed(2)}`;
  }

  if (number === 0) {
    return "0";
  }
  // what tier? (determines SI symbol)
  const tier = Math.floor(Math.log10(Math.abs(number)) / 3) || 0;

  // if zero, we don't need a suffix
  if (tier === 0) {
    return String(number);
  }

  // get suffix and determine scal
  const suffix = SI_SYMBOL[tier];
  const scale = Math.pow(10, tier * 3);

  // scale the number
  const scaled = number / scale;

  // format number and add suffix
  return scaled.toFixed(1) + suffix;
};

function inRange(num: number, min: number, max: number) {
  return (num - min) * (num - max) <= 0;
}
